// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"4a40c289","348":"8cf0ef48","352":"7042f1b2","453":"d855a71b","462":"c907927d","473":"805503a0","510":"e7728201"}[chunkId] + ".chunk.js";
};